import { useEffect } from 'react';

import { Button, Heading, Modal, Paragraph } from '@zillow/constellation-10';

import { PartialMessage } from '@zg-rentals/backend-styled-components';

import {
  emitClickContactSupportEvent,
  emitClickReturnToZillowEvent,
  emitViewBlockedUserModalEvent,
} from './clickstream/ClickstreamEvents';

import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';
import type { UserInfoRestrictionsWebApiDto } from '@zg-rentals/ts-rental-manager-api-beta-client';
import type { BLOCKED_USER_MODAL_TRIGGER_OBJECTS } from './clickstream/ClickstreamEvents';

type Props = {
  user: ZrmClickstreamUser & { restrictions?: UserInfoRestrictionsWebApiDto };
};

export const BlockedUserModal = ({ user }: Props) => {
  const restrictions = user.restrictions;

  useEffect(() => {
    if (user?.restrictions) {
      emitViewBlockedUserModalEvent({ user });
    }
  }, [user]);

  if (!restrictions) {
    return null;
  }
  const { partialMessages, title, ctaUrl, ctaText } = restrictions;

  const handleClose = () => {
    emitClickReturnToZillowEvent({ user });
  };

  const handleUrlClick = (e: React.MouseEvent<HTMLAnchorElement>, url: string, text: string) => {
    const triggerObject = text
      .toLowerCase()
      .replace(
        /\s+/g,
        '_',
      ) as (typeof BLOCKED_USER_MODAL_TRIGGER_OBJECTS)[keyof typeof BLOCKED_USER_MODAL_TRIGGER_OBJECTS];
    emitClickContactSupportEvent({ user, triggerObject });
  };

  return (
    <Modal
      header={<Heading level={1}>Alert</Heading>}
      body={
        <>
          <Heading level={2} textStyle="heading-sm" css={{ marginBottom: '400' }}>
            {title}
          </Heading>

          <Paragraph>
            <PartialMessage partialMessages={partialMessages} onUrlClick={handleUrlClick} />
          </Paragraph>
        </>
      }
      footer={
        <Button tone="brand" emphasis="filled" onClick={handleClose} asChild>
          <a href={ctaUrl}>{ctaText}</a>
        </Button>
      }
      open={true}
      useDismissProps={{ escapeKey: false, outsidePress: false }}
      closeButton={<span hidden />}
      size={{ base: 'fullScreen', md: 'md' }}
    />
  );
};

export default BlockedUserModal;
